import type { MinifiedTask } from '../../../../../api/tasks-client/task-client.type';
import { ContentPlaceholder } from '../../../../../components/content-placeholder/content-placeholder';
import { Table } from '../../../../../components/table/table';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setPerformanceActivePanel,
  setRelatedTasksPage,
  setRelatedTasksSelectedTask,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { Panel } from '../../../../../store/strategy-store/strategy-store.type';
import { useSearchedTasks } from '../related-tasks-tab.hooks';
import { customSort, getTableColumns } from './main-section.helpers';
import { usePlaceholderData } from './main-section.hooks';

export const MainSectionTable = () => {
  const tasks = useSearchedTasks();
  const page = useRelatedTasksTabStore((state) => state.page);
  const selectedTask = useRelatedTasksTabStore((state) => state.selectedTask);

  const placeholderData = usePlaceholderData();

  if (placeholderData) {
    return <ContentPlaceholder icon={placeholderData.icon} text={placeholderData.text} />;
  }

  return (
    <Table<MinifiedTask>
      data={tasks}
      columns={getTableColumns()}
      getRowId={(task) => task.id}
      defaultSortedBy={'name'}
      stickyHeader
      onRowClick={(task) => {
        setRelatedTasksSelectedTask(task);
        setPerformanceActivePanel(Panel.Side);
      }}
      currentPage={page}
      totalItems={tasks.length}
      onPageChange={setRelatedTasksPage}
      selectedRowId={selectedTask?.id}
      customSort={customSort}
    />
  );
};
